import { createSlice } from "@reduxjs/toolkit";

const dialogSlice = createSlice({
  name: "dialog",
  initialState: {
    state: false,
    options: {
      children: "Hi",
    },
  },
  reducers: {
    openDialog: (state, action) => {
      state.state = true;
      state.options = action.payload;
    },
    closeDialog: (state, action) => {
      state.state = false;
    },
  },
});

export const { openDialog, closeDialog } = dialogSlice.actions;

export const selectBASEDialogState = ({ base }) => base.dialog.state;

export const selectBASEDialogOptions = ({ base }) => base.dialog.options;

export default dialogSlice.reducer;
